import { SNACKBAR_SEARCH_PERSON_TO_NAVIGATE_ERROR_MSG } from 'constants/createIndividualConstants';
import { apiToFormTypes } from 'features/create-individual/hooks/use-create-individual-form/useCreateIndividualForm';
import { useSnackbar } from 'hooks/useSnackbar';
import {
  getErrMessageByFirstAndLastName,
  getFieldNameByType,
} from 'utils/get-first-last-name-err-msg/getErrMessageByFirstAndLastName';
export type Color = 'success' | 'warning';

export type SnackbarState = {
  message: string;
  color: Color;
  autoClose?: boolean;
  isOpen: boolean;
};

export type SnackbarMethod = {
  showSnackbar: (snackBarParam: SnackbarState) => void;
  closeSnackbar: () => void;
};

export type Snackbar = SnackbarState & SnackbarMethod;

export type SnackbarType = 'email' | 'phone';

type Props = {
  previewPerson: (params: { href?: string }) => void;
  clearErrors: (fieldName?: string) => void;
};

export const useCreateIndividualSnackbars = (props?: Props) => {
  const { previewPerson, clearErrors } = props || {};
  const phoneSnackbar = useSnackbar({ shouldCloseWhenNavigated: false });
  const emailSnackbar = useSnackbar({ shouldCloseWhenNavigated: false });
  const apiSnackbar = useSnackbar({ shouldCloseWhenNavigated: false });
  const searchErrorSnackbar = useSnackbar({ shouldCloseWhenNavigated: false });
  const snackbars = { email: emailSnackbar, phone: phoneSnackbar };

  const showContactWarningSnackbar = (
    type: SnackbarType,
    { firstName, lastName, href }: any
  ) => {
    const contactType = getFieldNameByType(type);
    snackbars[type].showSnackbar({
      color: 'warning',
      message: getErrMessageByFirstAndLastName(
        firstName,
        lastName,
        () => {
          if (href) previewPerson?.({ href });
          else {
            snackbars[type].closeSnackbar();
            clearErrors?.(apiToFormTypes[type]);
            apiSnackbar.showSnackbar({
              color: 'danger',
              message: SNACKBAR_SEARCH_PERSON_TO_NAVIGATE_ERROR_MSG,
              autoClose: false,
            });
          }
        },
        contactType
      ),
      autoClose: false,
    });
  };
  return {
    phoneSnackbar: phoneSnackbar as any,
    emailSnackbar: emailSnackbar as any,
    apiSnackbar: apiSnackbar as any,
    searchErrorSnackbar: searchErrorSnackbar as any,
    showContactWarningSnackbar,
  };
};
